/* TODO: Perhaps sync this with banckend service in the future */
export default Object.freeze({ 'CINEMA_KIOSK': { name: 'Cinema Kiosk', value: 'CINEMA_KIOSK'}, 'LED_PANEL': {name: 'LED Panel', value: 'LED_PANEL'}});